import { render, staticRenderFns } from "./wechat_main.vue?vue&type=template&id=41c5c9d4&scoped=true&"
import script from "./wechat_main.vue?vue&type=script&lang=js&"
export * from "./wechat_main.vue?vue&type=script&lang=js&"
import style0 from "./wechat_main.vue?vue&type=style&index=0&id=41c5c9d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c5c9d4",
  null
  
)

export default component.exports